import logo from "../assets/logo.jpeg";
import security from "../assets/security.jpg";
import teampic from "../assets/teampic.jpg";
import personnel from "../assets/personnel.jpg";
import consulting from "../assets/consulting.jpg";
import career from "../assets/career.png";
import logopng from "../assets/logopng.png";
import cam from "../assets/cam.jpg";
import book from "../assets/book.png";
import clipboard from "../assets/clipboard.png";
import humanbrain from "../assets/humanbrain.png";
import uniformed from "../assets/uniformed.jpg";
import training from "../assets/training.jpg";
import ontario from "../assets/ontario.jpg";
import onlineclass from "../assets/onlineclass.jpg";
import firstaid from "../assets/firstaid.jpg";
import ministry from "../assets/ministry.jpg";
import oboarding from "../assets/oboarding.jpg";
import specialized from "../assets/specialized.jpg";
import phone from "../assets/phone.png";
import background from "../assets/background.png";
import h1 from "../assets/h1.jpg";
import teamus from "../assets/teamus.jpg";
import achieve from "../assets/achieve.png";
import president from "../assets/president.jpg";
import licensed from "../assets/licensed.jpg";
import home from "../assets/home.png";
import book2 from "../assets/book2.png";
import wedevelop from "../assets/wedevelop.jpg";
import biggest from "../assets/biggest.jpg";
import exp from "../assets/image/experience.png";
import solve from "../assets/image/solving.png";
import Technology from "../assets/image/Technology.png";
import collaborate from "../assets/image/collaborate.png";
import hours from "../assets/image/24-hours.png";
import consec from "../assets/image/security.jpeg";
import homecontact from "../assets/image/Contact.jpeg";
import service1 from "../assets/image/Personnel.jpg";
import service2 from "../assets/image/Personnel1.jpg";
import service3 from "../assets/image/Personnel2.jpg";
import service4 from "../assets/image/Personnel3.jpg";
import service5 from "../assets/image/Personnel4.jpg";
import service6 from "../assets/image/Personnel5.jpg";
import expert from "../assets/image/Team.jpg";
import condo1 from "../assets/image/emergency.jpg";
import condo2 from "../assets/image/calling.jpg";
import condo3 from "../assets/image/login-banner1.jpg";
import condo4 from "../assets/image/welcoming.jpg";
import condo5 from "../assets/image/assistance.jpg";
import serviceback from "../assets/image/service-back.png";
import event2 from "../assets/image/crowd.jpg";
import event1 from "../assets/image/tailored.jpg";
import patrol from "../assets/image/mobile-patrols.jpg";
import patrol1 from "../assets/image/proactive.jpg";
import parking from "../assets/image/p1.jpg";
import parking1 from "../assets/image/p2.jpg";
import parking2 from "../assets/image/p3.jpg";
import parking3 from "../assets/image/p4.jpg";
import parking4 from "../assets/image/p5.jpg";
import parking5 from "../assets/image/p6.jpg";
import residental from "../assets/image/r1.jpg";
import residental1 from "../assets/image/r2.jpg";
import residental2 from "../assets/image/r3.jpg";
import residental3 from "../assets/image/r4.jpg";
import residental4 from "../assets/image/r5.jpg";
import residental5 from "../assets/image/r6.jpg";
import useof from "../assets/image/u1.jpeg";
import useof1 from "../assets/image/u2.jpg";
import useof2 from "../assets/image/u3.jpeg";
import useof3 from "../assets/image/u4.jpg";
import useof4 from "../assets/image/u5.png";

export default {
  logo,
  security,
  teampic,
  personnel,
  consulting,
  career,
  logopng,
  cam,
  book,
  clipboard,
  humanbrain,
  uniformed,
  training,
  ontario,
  onlineclass,
  firstaid,
  ministry,
  oboarding,
  specialized,
  phone,
  background,
  h1,
  teamus,
  achieve,
  president,
  licensed,
  home,
  book2,
  wedevelop,
  biggest,
  exp,
  solve,
  Technology,
  collaborate,
  hours,
  consec,
  homecontact,
  expert,
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  condo1,
  condo2,
  condo3,
  condo4,
  condo5,
  serviceback,
  event1,
  event2,
  patrol,
  patrol1,
  parking,
  parking2,
  parking1,
  parking3,
  parking4,
  parking5,
  residental,
  residental1,
  residental2,
  residental3,
  residental4,
  residental5,
  useof,
  useof1,
  useof2,
  useof3,
  useof4,
};
